export const mainGradient =
  'transparent linear-gradient(262deg, #2FFE5F 0%, #2CFE88 26%, #2CFE89 100%) 0% 0% no-repeat padding-box;';

export const sideMenuGradient =
  'transparent radial-gradient(353.33% 53.4% at 50.18% 46.6%, #F9F8F9 0%, #F9F8F9 46.87%, #DEDEDE 100%);';
